import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import Benefits from './style';

function BenefitCard({ icon, title }) {
    return (
        <Box sx={Benefits.BenefitsCard.container}>
            <Box component="img" src={icon} alt="" loading="lazy" sx={Benefits.BenefitsCard.image} />
            <Typography sx={Benefits.BenefitsCard.title}>{title}</Typography>
        </Box>
    );
}

BenefitCard.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

export default BenefitCard;
